import React, { useContext } from "react";
import { UploadDataType } from "@data-types/sow/PlayerSowTypes";
import { useTranslation } from "react-i18next";
import { PlayerSowInfo, SowDocumentUploadSection, SowFilesSection } from ".";
import { Button } from "@components/buttons";
import { useLocation } from "react-router-dom";
import { observer } from "mobx-react";

import { PlayerSowStoreContext } from "@state/context/sow/PlayerSowStoreContext";

export const SowSubmissionDocumentsOnly = observer(
	function SowSubmissionDocumentsOnly() {
		const { t } = useTranslation();

		const playerSowStore = useContext(PlayerSowStoreContext);

		const { search } = useLocation();
		const queryParams = new URLSearchParams(search);

		const params: Record<string, string> = {};

		queryParams.forEach((value, key) => {
			params[key] = value;
		});

		if (!playerSowStore) {
			return null;
		}

		const handleSubmitForm = async (
			e: React.FormEvent<HTMLFormElement>
		) => {
			e.preventDefault();

			const submitParams: UploadDataType = {
				requestId: params.requestId,
				userId: params.userId,
			};

			await playerSowStore.onSubmitDocumentsOnly(submitParams);
		};

		return (
			<form encType="multipart/form-data" onSubmit={handleSubmitForm}>
				<div className="card--primary">
					<div className="card--primary__header">
						<div className="card--primary__title title--primary">
							{t("PLAYER_SOW.TITLE")}
						</div>
					</div>
					<div className="card--primary__body">
						<PlayerSowInfo
							isFullForm={playerSowStore.isFormRequired}
						/>
						<SowDocumentUploadSection />
						<SowFilesSection />
						<div className="u-type--base u-mar--top--xsml">
							<label
								htmlFor="sowTextarea"
								className="label u-type--wgt--medium"
							>
								{t("PLAYER_SOW.TEXTAREA_PLACEHOLDER")}
							</label>
							<textarea
								maxLength={10000}
								className="input input--med input--textarea"
								onChange={(e) =>
									playerSowStore.setNotes(e.target.value)
								}
							></textarea>
						</div>
					</div>
					<div className="card--primary__footer">
						<Button
							type="submit"
							className="btn--base btn--accent card--primary__footer__btn"
							disabled={playerSowStore.files.length == 0}
							btnContent={t("PLAYER_SOW.SUBMIT_BUTTON")}
						/>
					</div>
					<div className="card--primary__footer u-mar--top--sml">
						<span className="label">
							{t("PLAYER_SOW.DATA_COLLECTION")}
						</span>
					</div>
				</div>
			</form>
		);
	}
);
